import { PropertyTypes } from "../../../../enums/PropertyTypes";
import { ISchema, ISchemaFilter, ISchemaProperty } from "../Schema";
import { FilterTypes } from "../../../../enums/FilterTypes";
import { FilterMatchType } from "../../../../enums/FilterMatchType";
import SidePanelRecallsView from "../../layout/SidePanel/layouts/SidePanelRecallsView";
import { formatRecallRequestedAtForList } from "../../../../helpers/DateHelper";

export const CustomerRecallsSchema: ISchema = {
    displayName: "Recalls",
    resultsKey: "recalls",
    GetSidePanelComponent: (data, onViewPage) => <SidePanelRecallsView data={data} onViewPage={onViewPage} />,
    props: [
        {
            name: 'id',
            type: PropertyTypes.string,
            key: true
        } as ISchemaProperty,
        {
            name: 'reference',
            displayName: 'Reference',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
        } as ISchemaProperty,
        {
            name: 'recallStatus',
            displayName: 'Status',
            type: PropertyTypes.status,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'dateRequested',
            displayName: 'Requested At',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            valueFormatter: (value: string | Date | null | undefined) =>
                formatRecallRequestedAtForList(value)
        } as ISchemaProperty,
        {
            name: 'itemCount',
            displayName: 'Item Count',
            type: PropertyTypes.number,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: true,
            valueFormatter: (value: number | null | undefined) => {
                if (value == null || value <= 0) {
                    return 'TBA';
                }
                return value;
            }
        } as ISchemaProperty,
        {
            name: 'priority',
            displayName: 'Priority',
            type: PropertyTypes.string,
            key: false,
            showInList: false,
            showInForm: false,
            showInView: false,
        } as ISchemaProperty,
        {
            name: 'accountName',
            displayName: 'Account',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
        } as ISchemaProperty,
        {
            name: 'requestType',
            displayName: 'Request Type',
            type: PropertyTypes.string,
            showInList: true,
            showInForm: false,
            showInView: false,
        } as ISchemaProperty,
    ],

    primaryFilter: {
        PropertyName: "FullRef",
        displayName: "Search",
        type: FilterTypes.search,
        required: false,
        className: "width--full",
        matchType: FilterMatchType.Equal,
        propertyType: PropertyTypes.string,
        placeHolder: "Enter recall reference"
    } as ISchemaFilter,

    filters: [
        {
            PropertyName: "RecallType",
            entityName: "recallTypes",
            displayName: "Request Type",
            type: FilterTypes.select,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.string,
        } as ISchemaFilter,
        {
            PropertyName: "AccountId",
            entityName: "accounts",
            displayName: "Account",
            type: FilterTypes.select,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.uuid,
        } as ISchemaFilter,
        {
            PropertyName: "Status",
            entityName: "recallStatuses",
            displayName: "Status",
            type: FilterTypes.select,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.int
        } as ISchemaFilter,
    ],

    children: [],
};
